import {
  AD_LABEL,
  AM_LABEL,
  PM_LABEL,
} from '../../constants/general';

const determineOptionBackgroundColor = (color, isDisabled, isSelected, isFocused, availabilityType) => {
  if (isDisabled) {
    return null;
  }
  if (isSelected) {
    return color;
  }
  if (isFocused) {
    return availabilityType === AD_LABEL ? '#77777716' :`${color}16`;
  }
  return null;
}

const determineOptionColor = (color, isDisabled, isSelected) => {
  if (isDisabled) {
    return '#ccc';
  }
  if (isSelected) {
    return 'black';
  }
  return color;
}

export const availabilityColorStyles = {
  control: styles => ({ ...styles, backgroundColor: 'white' }),
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    let color;
    switch (data.availabilityType) {
      case AM_LABEL:
        color = '#ff9800';
        break;
      case PM_LABEL:
        color = '#ce0075';
        break;
      default:
        color = styles.color;
    } 
    return {
      ...styles,
      backgroundColor: determineOptionBackgroundColor(color, isDisabled, isSelected, isFocused, data.availabilityType),
      color: determineOptionColor(color, isDisabled, isSelected),
      cursor: isDisabled ? 'not-allowed' : 'default',

      ':active': {
        ...styles[':active'],
        backgroundColor: !isDisabled && (isSelected ? color : `${color}48`),
      },
    };
  },
  multiValue: (styles, { data }) => {
    let color;
    switch (data.availabilityType) {
      case AM_LABEL:
        color = '#ff9800';
        break;
      case PM_LABEL:
        color = '#ce0075';
        break;
      default:
        color = styles.color;
    } 
    return {
      ...styles,
      backgroundColor: `${color}16`,
    };
  },
  multiValueLabel: (styles, { data }) => {
    let color;
    switch (data.availabilityType) {
      case AM_LABEL:
        color = '#ff9800';
        break;
      case PM_LABEL:
        color = '#ce0075';
        break;
      default:
        color = styles.color;
    }
    return {
      ...styles,
      color,
      };
  },
  multiValueRemove: (styles, { data }) => {
    let color;
    switch (data.availabilityType) {
      case AM_LABEL:
        color = '#ff9800';
        break;
      case PM_LABEL:
        color = '#ce0075';
        break;
      default:
        color = '#777777';
    }
    return {
      ...styles,
      color,
      ':hover': {
        backgroundColor: color,
        color: 'white',
      }
    };
  },
};

export const customSettingsSelectStyles = {
  control: () => ({
    alignItems: 'center',
    backgroundColor: '#ffffff',
    borderColor: '#9e9e9e',
    borderBottomStyle: 'solid',
    borderWidth: '1px',
    cursor: 'default',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    outline: '0 !important',
    paddingTop: '10px',
    position: 'relative',
    transition: 'all 100ms',
    boxSizing: 'border-box',
  }),
  placeholder: (base) => ({
    ...base,
    marginLeft: '-8px',
    position: 'absolute',
    top:  -2,
    transition: 'top 0.1s, font-size 0.1s',
    fontSize: '1.1rem',
  }),
  valueContainer: (base) => ({
    ...base,
    overflow: 'visible'
  }),
  singleValue: (base, { data }) => ({
    ...base,
    marginLeft: '-8px',
    color: data.isActive === false
      ? '#ff0000'
      : base.color,
  }),
  input: (base) => ({
      ...base,
      marginLeft: '-8px',
  }),
  option: (base, { data }) => ({
    ...base,
    color: data.isActive === false
      ? '#ff0000'
      : base.color,
  }),
};

export const customMappedLocationStyles = {
  singleValue: (base, { data }) => ({
    ...base,
    color: data.shouldWarn
      ? '#ff9800'
      : base.color,
  }),
  option: (base, { data }) => ({
    ...base,
    color: data.shouldWarn
      ? '#ff9800'
      : base.color,
  }),
};
